module.exports = __webpack_public_path__ + "static/media/bitgert-logo.da8858be.png";